export default "__VITE_ASSET__226a059b__"